export default "__VITE_ASSET__uUhTCSvj__"